export enum AclOwnership {
  Any = 'any',
  Own = 'own',
}
